import Div from "@jumbo/shared/Div/Div";
import {Box, Paper, Tab, Tabs} from "@mui/material";
import TabPanel from "app/pages/Docgen/components/common/mui-tabpanel/MuiTabpanel";
import "./MatterDetails.css";
import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import {get, put} from "../../../common/network";
import ContactsTab from "./ContactsTab";
import FormsTab from "./FormsTab";
import HistoryTab from "./HistoryTab";
import MatterDetailsTab from "./MatterDetailsTab";
import Notes from "./NotesTab";
import RelatedMattersTab from "./RelatedMattersTab";
import WorkbenchTab from "./WorkbenchTab";

const MatterDetails = ({id,isXfa }) => {
  //#region for states
  const [activeTab, setActiveTab] = useState(0);
  const [note, setNote] = useState("This is a note!");
  const [collapse1, setCollapse1] = useState(false);
  const [collapse2, setCollapse2] = useState(false);
  const [isMatterDetails, setMatterDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try{
        const response = await get(`docgen/matters/${id}`);
        setMatterDetails(response?.data || []);
      } catch (error){
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const setNewNote = async (notes) => {
    try {
      const response = await put(`docgen/matters/${id}`, { notes });
      if (response?.success === true) {
        toast.success(response.message);
      }
    } catch (error) {
    }
   
  };

  //#endregion

  return (
    <div className="page-content-wrapper">
      <Box className="w-100">
        <div>
          <Paper>
            <Div className="matter-details-tab-wrapper">
              <Tabs
                value={activeTab}
                onChange={(event, newValue) => {
                  setActiveTab(newValue);
                }}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                aria-label="scrollable force tabs example"
                className="mui-tab-header"
              >
                <Tab label="Docket Details" />
                <Tab label="Contacts" />
                <Tab label="Forms" />
                <Tab label="History" />
                <Tab label="Notes" />
                <Tab label="Related Matters" />
                {/*<Tab label="Workbench" />*/}
              </Tabs>
              <TabPanel value={activeTab} index={0}>
                <MatterDetailsTab
                  id={id}
                  collapse1={collapse1}
                  setCollapse1={setCollapse1}
                  collapse2={collapse2}
                  setCollapse2={setCollapse2}
                  isMatterDetails={isMatterDetails}
                  isLoading={isLoading}
                />
              </TabPanel>
              <TabPanel value={activeTab} index={1}>
                <ContactsTab id={id} />
              </TabPanel>
              <TabPanel value={activeTab} index={2}>
                <FormsTab
                    id={id}
                    isMatterDetails={isMatterDetails}
                    isLoading={isLoading}
                />
              </TabPanel>
              <TabPanel value={activeTab} index={3}>
                <HistoryTab id={id} isXfa={isXfa}/>
              </TabPanel>
              <TabPanel value={activeTab} index={4}>
                <Notes
                  id={id}
                  note={note}
                  setNote={setNote}
                  onSubmit={(values) => {
                    setNewNote(values);
                  }}
                />
              </TabPanel>
              <TabPanel value={activeTab} index={5}>
                <RelatedMattersTab id={id} />
              </TabPanel>
              <TabPanel value={activeTab} index={6}>
                <WorkbenchTab id={id} />
              </TabPanel>
            </Div>
          </Paper>
        </div>
      </Box>
    </div>
  );
};

export default MatterDetails;